import { useEffect, useRef } from 'react';

function useVersionChecker() {
  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch('/meta.json', { cache: 'no-store' });
        const data = await res.json();
        const currentVersion = localStorage.getItem('app_version');

        if (!currentVersion || currentVersion !== data.buildDateTime) {
          localStorage.setItem('app_version', data.buildDateTime);
          window.location.reload();
        }
      } catch (err) {
        console.error('Version check failed', err);
      }
    };

    checkVersion();
  }, []);
}

export default useVersionChecker;
